// extracted by mini-css-extract-plugin
export default {"root":"_3RhgY","favoriteIconActive":"_24z_h","animationTitle":"_3LE5S","favorite-success-action":"_3FP3g","animationTitleClose":"_1BiVh","favorite-close-action":"_36YK1"};